import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p className="footer-copy">
      Designed &amp; built by <span>Taylor Guy</span>
    </p>
    <ul className="footer-links">
      <li><a href="https://github.com/tguy5837" target="_blank" rel="noreferrer">GitHub</a></li>
      <li><a href="https://www.linkedin.com/in/douglas-guy-51a44322a/" target="_blank" rel="noreferrer">LinkedIn</a></li>
      <li><a href="mailto:tguy5837@gmail.com">Email</a></li>
    </ul>
  </footer>
);

export default Footer;
